import { Component, OnInit, Input, Output, OnDestroy, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../api.service';
import {ObservablesService} from '../observables.service';
import { Subject } from "rxjs";
import { DatePipe } from '@angular/common';
import { _ } from 'underscore';
@Component({
  selector: 'app-mobile-dashboard',
  templateUrl: './mobile-dashboard.component.html',
  styleUrls: ['./mobile-dashboard.component.scss']
})
export class MobileDashboardComponent implements OnInit {
@Output() onTabSelected: EventEmitter<any> = new EventEmitter<any>();
@Output() onLastRoleSelected: EventEmitter<any> = new EventEmitter<any>();

_selectedClient:any;
_selectedData:any;
@Input() set selectedClient(selectedClient){

  // console.log("selectedClients==",selectedClient)

  this._selectedClient =  selectedClient;

  // if(!_.isEmpty(this._selectedClient) && !_.isEmpty(this.loggedUserInfo)){
  //
  //       if(this.selectedRangeDates){
  //
  //         this.getAllSlips();
  //       }
  //
  // }else if(this._selectedClient === undefined){
  //
  //   if(this.selectedRangeDates && !_.isEmpty(this.loggedUserInfo)){
  //
  //     this.getAllSlips(true,true)
  //   }
  // }else{
  //   if(this.selectedRangeDates){
  //     // console.log("11")
  //     this.getAllSlips(true,true)
  //   }
  // }
}


@Input() set selectedData(selectedData){
  // console.log("party  date selected==",selectedData)

  // this.selectedLevelData = []
  if(selectedData === undefined){
  }else{
    if(this.loggedUserInfo === undefined){
      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          this._selectedData = selectedData;
          this.proceedData(selectedData)
        }
      })
    }else{
      this.proceedData(selectedData)
    }


    // this.selectedRangeDates = selectedData.selectedDates;
    // this.selectedParty = (selectedData.selectedParty)?selectedData.selectedParty.id:null
    // if(this.selectedParty){
    //
    //     if(!_.isEmpty(this.loggedUserInfo)){
    //       this.getDatewiseSlips(true,true,false)
    //     }else{
    //       if(this.loggedUserInfo === undefined){
    //         this.api.getLoggedUserInfo().then((res:any)=>{
    //           if(res.data.length > 0){
    //             this.loggedUserInfo = res.data[0];
    //             this.getDatewiseSlips(true,true,false)
    //           }
    //         })
    //       }
    //     }
    //
    // }else{
    //
    //
    //   if(!_.isEmpty(this._selectedClient) && !_.isEmpty(this.loggedUserInfo)){
    //
    //     this.getAllSlips();
    //   }else{
    //     if(!_.isEmpty(this.loggedUserInfo)){
    //
    //       this.getAllSlips(true,true)
    //     }else{
    //       if(this.loggedUserInfo === undefined){
    //         this.api.getLoggedUserInfo().then((res:any)=>{
    //           if(res.data.length > 0){
    //             this.loggedUserInfo = res.data[0];
    //             this.getAllSlips(true,true)
    //           }
    //         })
    //       }
    //     }
    //   }
    // }
  }
}

loggedUserInfo:any;
user_id:any;
selectedParty:any=null;
selectedTag:any=null;
selectedRangeDates:any=null;
slips:any=[];
unpaidInvoices:any=[];
paidInvoices:any=[];
bsValue = new Date();
bsRangeValue: Date[];
maxDate = new Date();
totalSlipAmount:number = 0;
refreshSlipListObserver:any;
setInvoicedSlipsObserver:any;
invoiceSlipStatus:boolean = true;
selectedLevelData:any=[]
selectedDataFromHeader:any=[]
@ViewChild('target',{static:false}) target:ElementRef;

proceedData(selectedData){

  // console.log("selectedParty==",selectedData)
  this.selectedDataFromHeader = selectedData
  this.selectedRangeDates = selectedData.selectedDates;
  this.selectedParty = (selectedData.selectedParty)?selectedData.selectedParty.id:null
  this.selectedTag = (selectedData.selectedTag)?selectedData.selectedTag.id:null
  // console.log("selectedTag==",this.selectedTag)
  if(this.selectedParty || this.selectedTag){
    this.selectedLevelData = []
    this._selectedClient = null
    if(this.selectedParty && this.selectedTag){
      this.getSlips(false,true,true)
      this.getUnpaidInvoices(false,true,true)
      this.getPaidInvoices(false,true,true)

    }else if(this.selectedParty && !this.selectedTag){
      this.getSlips(false,true,false)
      this.getUnpaidInvoices(false,true,false)
      this.getPaidInvoices(false,true,false)

    }else if(!this.selectedParty && this.selectedTag){
      this.getSlips(false,false,true)
      this.getUnpaidInvoices(false,false,true)
      this.getPaidInvoices(false,false,true)

    }else{
      this.getSlips(false)
      this.getUnpaidInvoices(false)
      this.getPaidInvoices(false)
    }

  }else if(!this.selectedParty || !this.selectedTag){
    if(!_.isEmpty(this._selectedClient)){
      this.getSlips(true)
      this.getUnpaidInvoices(true)
      this.getPaidInvoices(true)
    }else{
      this.getSlips(false)
      this.getUnpaidInvoices(false)
      this.getPaidInvoices(false)
    }
  }

  this.target.nativeElement.scrollIntoView();
}

userSelected(data:any){
    // console.log("selectedLevelData=",data)
    this.selectedLevelData = data;
}

setClient(data){
  // this.selectedClient = data;
  // console.log("client in mobile selected=",data)
  // this.proceedData(data)
  this.observables.resetPartySearchStatus.next()
  this._selectedClient =  data;
  this.selectedDataFromHeader = []
  this.proceedData(this._selectedData)
  this.onLastRoleSelected.emit(data)
}
getSlips(client_status=false,party_status=false,tag_status=false){
  let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');

  let conditions:any;
  let fields:any;
  let joins:any;

  // console.log("this.client_status==",client_status)
  if(client_status){
    // console.log("this.invoiceSlipStatus==",this.invoiceSlipStatus)
    if(!this.invoiceSlipStatus){
      fields=["false as checked_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
      conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id,"I.delete_status":0};
      joins = [
        {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
        {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]}
      ]
    }else{
      fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
      conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id};
      joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]

    }
  }else{

    if(party_status && tag_status){
      if(!this.invoiceSlipStatus){
        fields=["false as checked_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag, "I.delete_status":0};
        joins = [
          {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
          {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]},
          {type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},
          {type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}
        ]
      }else{

        fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag};
        joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
      }

    }else if(party_status && !tag_status){
      if(!this.invoiceSlipStatus){
        fields=["false as checked_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"I.delete_status":0};
        joins = [
          {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
          {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]}
        ]
      }else{
        fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id};
        joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
      }
    }else if(!party_status && tag_status){
      if(!this.invoiceSlipStatus){
        fields=["false as checked_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag,"I.delete_status":0};
        joins = [
          {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
          {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]},
          {type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},
          {type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}
        ]
      }else{
        fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"ST.tag_id":this.selectedTag};
        joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.slip_id = S.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
      }
    }else if(!party_status && !tag_status){
      // console.log("in else")
      if(!this.invoiceSlipStatus){
        fields=["false as checked_status,I.invoice_number, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id, "I.delete_status":0};
        joins = [
          {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
          {type:"left",table:"master_invoices as I",conditions:["I.id = S.master_invoice_id"]}
        ]
      }else{
        fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
        conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id};
        joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
      }
    }
  }


  this.api.send("findDb",{
    fields:fields,
    table:"master_slips as S",
    joins:joins,
    conditions:[conditions],
    order:"S.id DESC"
  }).then((res:any)=>{
    // console.log(res)
    this.slips=res.data;

  })
}

getUnpaidInvoices(client_status=false,party_status=false,tag_status=false){
  let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');

  let conditions:any;
  let fields:any;
  let joins:any;
  if(client_status){
    joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
    conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
  }else{

    if(party_status && tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
      conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};
    }else if(party_status && !tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
      conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id};
    }else if(!party_status && tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
      conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};

    }else if(!party_status && !tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
      conditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
    }
  }


  this.api.send("findDb",{
    fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
    table:"master_invoices as I",
    joins:joins,
    conditions:[conditions],
    order:"I.id DESC"
  }).then((res:any)=>{
    this.unpaidInvoices=res.data;

  })
}


getPaidInvoices(client_status=false,party_status=false,tag_status=false){
  let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');

  let conditions:any;
  let fields:any;
  let joins:any;
  if(client_status){
    joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
    conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
  }else{

    if(party_status && tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};
    }else if(party_status && !tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.party_id":this.selectedParty,"I.business_id":this.loggedUserInfo.business_id};
    }else if(!party_status && tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]},{type:"left",table:"slip_invoice_tags as ST",conditions:["ST.invoice_id = I.id"]},{type:"left",table:"tags as T",conditions:["T.id = ST.tag_id"]}]
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id, "ST.tag_id":this.selectedTag};

    }else if(!party_status && !tag_status){
      joins = [{type:"left",table:"parties as P",conditions:["P.id = I.party_id"]}]
      conditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
    }
  }


  this.api.send("findDb",{
    fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
    table:"master_invoices as I",
    joins:joins,
    conditions:[conditions],
    order:"I.id DESC"
  }).then((res:any)=>{
    this.paidInvoices=res.data;

  })
}
  constructor(public datePipe:DatePipe, private api:ApiService, private observables:ObservablesService) { }

  ngOnDestroy(){
    // this.refreshSlipListObserver.unsubscribe()
    this.setInvoicedSlipsObserver.unsubscribe()
  }
  ngOnInit() {

    this.setInvoicedSlipsObserver = this.observables.setInvoicedSlips.subscribe(()=>{
      this.invoiceSlipStatus = !this.invoiceSlipStatus
      if(this.invoiceSlipStatus){

        if(this.selectedParty || this.selectedTag){

          if(this.selectedParty && this.selectedTag){
            this.getSlips(false,true,true)
            this.getUnpaidInvoices(false,true,true)
            this.getPaidInvoices(false,true,true)
          }else if(this.selectedParty && !this.selectedTag){
            this.getSlips(false,true,false)
            this.getUnpaidInvoices(false,true,false)
            this.getPaidInvoices(false,true,false)
          }else if(!this.selectedParty && this.selectedTag){
            this.getSlips(false,false,true)
            this.getUnpaidInvoices(false,false,true)
            this.getPaidInvoices(false,false,true)
          }else{
            this.getSlips(false)
            this.getUnpaidInvoices(false)
            this.getPaidInvoices(false)
          }

        }else if(!this.selectedParty || !this.selectedTag){
          if(!_.isEmpty(this._selectedClient)){
            this.getSlips(true)
            this.getUnpaidInvoices(true)
            this.getPaidInvoices(true)
          }else{
            this.getSlips(false)
            this.getUnpaidInvoices(false)
            this.getPaidInvoices(false)
          }
        }
      }
    })
    // this.refreshSlipListObserver = this.observables.refreshSlipListStatus.subscribe(()=>{
    //   if(this.loggedUserInfo === undefined){
    //     this.api.getLoggedUserInfo().then((res:any)=>{
    //       if(res.data.length > 0){
    //         this.loggedUserInfo = res.data[0];
    //         // if(this.selectedParty){
    //         //   if(!_.isEmpty(this._selectedClient)){
    //         //   // if(this._selectedClient !== undefined){
    //         //
    //         //     this.getDatewiseSlips()
    //         //   }else{
    //         //     this.getDatewiseSlips(true,true,false)
    //         //   }
    //         // }else{
    //         //   if(!_.isEmpty(this._selectedClient)){
    //         //   // if(this._selectedClient !== undefined){
    //         //
    //         //     this.getAllSlips();
    //         //   }else{
    //         //     this.getAllSlips(true,true);
    //         //   }
    //         // }
    //       }else{
    //         this.api.logOut()
    //       }
    //     })
    //   }
    //
    // })

    if(this.loggedUserInfo === undefined){
      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          // console.log("loggedUserInfo=",this.loggedUserInfo)
        }else{
          this.api.logOut()
        }
      })
    }
  }



  gotoMain(){
    this.onLastRoleSelected.emit(this._selectedClient)
    this.onTabSelected.emit()
  }

  // getAllSlips(status = true,allStatus = false){
  //   let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  //   let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
  //
  //   let slipConditions:any;
  //   let fields:any;
  //   let joins:any;
  //   if(status && !allStatus){
  //     fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //     joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //     slipConditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id};
  //   }else if(status && allStatus){
  //     fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //     joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //     slipConditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id};
  //   }else if(!status && allStatus){
  //     fields=["false as checked_status, I.invoice_no, I.invoice_date, S.*, P.*, S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //     joins = [
  //       {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
  //       {type:"left",table:"slip_invoices as SI",conditions:["SI.slip_id = S.id"]},
  //       {type:"left",table:"invoices as I",conditions:["I.id = SI.invoice_id"]}
  //     ]
  //     slipConditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"I.delete_status":0};
  //   }else{
  //     fields=["false as checked_status, I.invoice_no, I.invoice_date, S.*, P.*, S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //     joins = [
  //       {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
  //       {type:"left",table:"slip_invoices as SI",conditions:["SI.slip_id = S.id"]},
  //       {type:"left",table:"invoices as I",conditions:["I.id = SI.invoice_id"]}
  //     ]
  //     slipConditions = {"S.invoice_status ":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id,"I.delete_status":0};
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:fields,
  //     table:"slips as S",
  //     joins:joins,
  //     conditions:[slipConditions],
  //     order:"S.id DESC"
  //   }).then((res:any)=>{
  //     // console.log(res)
  //     this.slips=res.data;
  //     // console.log("slips==",this.slips)
  //
  //   })
  //
  //   let unpaidConditions:any;
  //   if(allStatus){
  //     unpaidConditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
  //   }else{
  //     unpaidConditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
  //     table:"invoices as I",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = I.party_id"]
  //     }],
  //     conditions:[unpaidConditions],
  //     order:"I.id DESC"
  //   }).then((res:any)=>{
  //     this.unpaidInvoices=res.data;
  //
  //   })
  //
  //   let paidConditions:any;
  //   if(allStatus){
  //     paidConditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id};
  //   }else{
  //     paidConditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0,"I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
  //     table:"invoices as I",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = I.party_id"]
  //     }],
  //     conditions:[paidConditions],
  //     order:"I.id DESC"
  //   }).then((res:any)=>{
  //     this.paidInvoices=res.data;
  //
  //   })
  // }


  // getDatewiseSlips(status = true,specific_status = false,allStatus = false){
  //   this.slips= []
  //   // console.log("selected date ranges=",status, specific_status, allStatus)
  //   this.bsRangeValue = [this.maxDate,this.bsValue];
  //   let from_date:any=this.datePipe.transform(this.selectedRangeDates[0], 'yyyy-MM-dd');
  //   let to_date:any=this.datePipe.transform(this.selectedRangeDates[1], 'yyyy-MM-dd');
  //   let conditions:any;
  //   let fields:any;
  //   let joins:any;
  //   if(status){
  //     if(specific_status && !allStatus){
  //       fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id};
  //       joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //
  //     }else if(specific_status && allStatus){
  //       fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.business_id":this.loggedUserInfo.business_id};
  //       joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //     }else{
  //
  //       fields=["false as checked_status, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status !":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id};
  //       joins = [{type:"left",table:"parties as P",conditions:["P.id = S.party_id"]}]
  //     }
  //   }else{
  //     if(allStatus){
  //
  //       fields=["false as checked_status,I.invoice_no, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"I.delete_status":0};
  //       joins = [
  //         {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
  //         {type:"left",table:"slip_invoices as SI",conditions:["SI.slip_id = S.id"]},
  //         {type:"left",table:"invoices as I",conditions:["I.id = SI.invoice_id"]}
  //       ]
  //     }else{
  //
  //       fields=["false as checked_status,I.invoice_no, I.invoice_date, S.*, P.*,S.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(slip_date, '%Y-%m-%d')) AS days"]
  //       conditions = {"S.invoice_status":1,"S.slip_date >":from_date,"S.slip_date <":to_date,"S.party_id":this.selectedParty,"S.business_id":this.loggedUserInfo.business_id,"S.user_id":this._selectedClient.id,"I.delete_status":0};
  //       joins = [
  //         {type:"left",table:"parties as P",conditions:["P.id = S.party_id"]},
  //         {type:"left",table:"slip_invoices as SI",conditions:["SI.slip_id = S.id"]},
  //         {type:"left",table:"invoices as I",conditions:["I.id = SI.invoice_id"]}
  //       ]
  //     }
  //   }
  //
  //   this.api.send("findDb",{
  //     fields:fields,
  //     table:"slips as S",
  //     joins:joins,
  //     conditions:[conditions],
  //     order:"S.id DESC"
  //   }).then((res:any)=>{
  //     // console.log(res)
  //     this.slips=res.data;
  //   })
  //   let unpaidConditions:any;
  //   if(specific_status && !allStatus){
  //     unpaidConditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id};
  //   }else if(specific_status && allStatus){
  //
  //     unpaidConditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.business_id":this.loggedUserInfo.business_id};
  //   }
  //   else{
  //     unpaidConditions = {"I.paid_status":0,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id}
  //   }
  //   this.api.send("findDb",{
  //     fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
  //     table:"invoices as I",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = I.party_id"]
  //     }],
  //     conditions:[unpaidConditions],
  //     order:"I.id DESC"
  //   }).then((res:any)=>{
  //
  //     this.unpaidInvoices=res.data;
  //
  //   })
  //
  //   let paidConditions:any;
  //   if(specific_status && !allStatus){
  //     paidConditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id};
  //   }else if(specific_status && allStatus){
  //
  //     paidConditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.business_id":this.loggedUserInfo.business_id};
  //   }else{
  //     paidConditions = {"I.paid_status":1,"I.invoice_date >":from_date,"I.invoice_date <":to_date,"I.delete_status":0, "I.party_id":this.selectedParty, "I.business_id":this.loggedUserInfo.business_id,"I.user_id":this._selectedClient.id};
  //   }
  //   this.api.send("findDb",{
  //     fields:["I.*, P.*,I.id as id, DATEDIFF(CURDATE(),STR_TO_DATE(invoice_date, '%Y-%m-%d')) AS days"],
  //     table:"invoices as I",
  //     joins:[{
  //       type:"left",
  //       table:"parties as P",
  //       conditions:["P.id = I.party_id"]
  //     }],
  //     conditions:[paidConditions],
  //     order:"I.id DESC"
  //   }).then((res:any)=>{
  //     // console.log("asdasd=",res)
  //     this.paidInvoices=res.data;
  //
  //   })
  // }

  getSlipGstInclusiveAmount(){
    return this.slips.reduce( ( accumulator, currentValue ) => {
      return accumulator +( currentValue.total_amount + currentValue.gst_total_amount);
    }, 0);
  }

  totalPaidInvoiceAmount(){
    return this.paidInvoices.reduce( ( accumulator, currentValue ) => {
      return accumulator + parseFloat(currentValue.total_amount);
    }, 0);
  }

  totalUnpaidInvoiceAmount(){
    return this.unpaidInvoices.reduce( ( accumulator, currentValue ) => {
      return accumulator + parseFloat(currentValue.balance);
    }, 0);
  }


  totalPayableAmount(){
    return this.getSlipGstInclusiveAmount() + this.totalUnpaidInvoiceAmount();
  }

}
